import proxy from "api/proxy";

async function actionButton({ button, model, saveForm, record, storeId }) {
  const { store, active } = record;
  let res = {
    msg: null,
    data: null,
    error: null,
    button: button,
  };
  if (button.method && typeof button.method !== "string") {
    console.log(
      "Deprecation attribute <method> use onClick instead in layout....",
    );
    res = button.method(active, store);
    return res;
  }
  if (button.onClick) {
    res = button.onClick(active, store);
    return res;
  }
  const storeSize = Object.keys(store).length;
  if (!button || (button?.button_method && storeSize > 1)) {
    res = await saveForm(storeId);
    if (!res.recId && active.id < 0) return res;
    active.id = res.recId ?? active.id;
  }
  const dataToAPI = {
    model: model,
    method: button.button_method ?? button.method,
  };
  let response = {};
  if (button.button_method) {
    dataToAPI.ids = [active.id];
    dataToAPI.method = button.button_method;
    response = await proxy.buttonMethod(dataToAPI);
  } else {
    dataToAPI.args = [store];
    dataToAPI.method = button.method;
    response = await proxy.methodCall(dataToAPI);
  }
  res = { ...res, ...response };
  console.log("actionButton res....", res);
  return res;
}

export default actionButton;
